import React from "react";
import {
  FaPlus,
  FaUserTie,
} from "react-icons/fa";

import Button from "../../../../components/Button/Button";

export default function EmptyState({
  onCreate,
}) {
  return (
    <div className="rounded-3xl border border-dashed border-slate-300 bg-white p-10 text-center shadow-sm dark:border-slate-700 dark:bg-slate-900">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400">
        <FaUserTie className="text-2xl" />
      </div>

      <h3 className="mt-4 text-xl font-bold text-slate-900 dark:text-white">
        Aucun acteur trouvé
      </h3>

      <p className="mx-auto mt-2 max-w-xl text-sm text-slate-600 dark:text-slate-300">
        Aucun acteur ne correspond à votre
        recherche ou à vos filtres.
      </p>

      <div className="mt-5">
        <Button
          text="Ajouter un acteur"
          onClick={onCreate}
          icon={FaPlus}
          className="!rounded-2xl !px-5 !py-2.5"
        />
      </div>
    </div>
  );
}